import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import PropTypes from 'prop-types';
import { Chart, ChartProvider, ChartLegend } from '@facet-wealth/design';
import ChartTooltip from './ChartTooltip';
import { convertChartDataResourceToDataSet } from './utils';

const UpdatedScenarioChart = ({
  chartDataResource,
  onClick,
  showLegend,
}) => {
  const dataset = React.useMemo(() => {
    return convertChartDataResourceToDataSet(chartDataResource);
  }, [chartDataResource?.instanceId()]);

  const yAxisTicks = (chartDataResource.attr('yAxisTicks') ?? []).map(tick => +tick);
  const hideXAxisTicks = chartDataResource?.isTruthy('hideXAxisTicks');
  const yAxisGridlines = chartDataResource?.isTruthy('yAxisGridlines');

  return (
    <ChartProvider key={chartDataResource?.instanceId()} dataset={dataset}>
      <Chart
        tooltip={hideXAxisTicks ? undefined : ChartTooltip}
        onClick={onClick}
        yAxisGridlines={yAxisGridlines}
        xAxisTicks={hideXAxisTicks ? [] : undefined}
        yAxisTicks={yAxisTicks.length > 0 ? yAxisTicks : undefined}
        allowThickBarChart={chartDataResource?.isTruthy('allowThickBarChart')}
        alwaysShowY0={chartDataResource?.isTruthy('alwaysShowY0')}
      />
      {showLegend ? (
        <Box paddingBottom={2}>
          <ChartLegend />
        </Box>
      ) : null}
    </ChartProvider>
  );
};

UpdatedScenarioChart.defaultProps = {
  onClick: undefined,
  showLegend: false,
};

UpdatedScenarioChart.propTypes = {
  chartDataResource: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  showLegend: PropTypes.bool,
};

export default UpdatedScenarioChart;
